import { observer } from "mobx-react-lite";

import { SettingsTable } from "../../SettingsTable";
import { CustomModel } from "../types";

import { useCustomModelsTable } from "./hooks/useCustomModelsTable";

export const CustomModelsTable = observer(
  ({
    onEditModel,
  }: {
    onEditModel: (model: CustomModel, isViewing?: boolean) => void;
  }) => {
    const {
      columns,
      contextMenuItems,
      actions,
      isDeletingModel,
      isModelsLoading,
      models,
    } = useCustomModelsTable({
      onEditModel,
    });

    return (
      <SettingsTable<CustomModel>
        data={models}
        actions={actions}
        columns={columns}
        onRowClick={onEditModel}
        contextMenuItems={contextMenuItems}
        isLoading={isDeletingModel || isModelsLoading}
        emptyStateMessage="No custom models found"
      />
    );
  },
);
